"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DESELECT_MESSAGE = void 0;
exports.DESELECT_MESSAGE = "DESELECT_MESSAGE";
function default_1(chatId) {
    return {
        type: exports.DESELECT_MESSAGE,
        payload: {
            chatId
        }
    };
}
exports.default = default_1;
